<template>
  <div class="person">
    <a-tabs tabPosition="top" :tabBarGutter="0" v-if="personInfo" class="tab" defaultActiveKey="1">
      <a-tab-pane class="tab-item" :tab="$t('global.basicInfo')" key="1">
        <EntityInfo v-if="titles && infos" :titles="titles" :infos="infos" :showImage="false" layoutDirection="row" />
        <!-- <div class="basic">
          <p>姓名: {{personInfo.姓名}}</p>
          <p>机构: {{personInfo.org}}</p>
          <p>分组: {{personInfo.group}}</p>
        </div> -->
      </a-tab-pane>
      <a-tab-pane class="tab-item" :tab="`${$t('global.allPoints')}(${allArr.length})`" key="4" >

        <!-- 使用list -->
         <a-list
          class="list"
          v-if="allArr.length > 0"
          itemLayout="horizontal"
          :dataSource="allArr"
          :pagination="allArr.length > 4 ? paginationAll : false"
          size="small"
        >
          <a-list-item class="list-item" slot="renderItem" slot-scope="item, index">
            <a-list-item-meta :key="index" @click="clickAllAddr(item)">
              <div slot="description">
                <div>{{item.address}}</div>
                <div>{{$t('supervise.locationType') + `: ${computedLocationType(item.loc_type).value}`}}<zx-icon :type="computedLocationIcon(item.loc_type)" /></div>
                <div v-if="item.message">{{item.message}}</div>
              </div>
              <div slot="title" >{{item.time}}</div>
            </a-list-item-meta>
            <div slot="actions" class="item-index">{{item.index}}</div>
          </a-list-item>
        </a-list>
        <div class="empty" v-else>{{$t('global.noInfo')}}</div>
      </a-tab-pane>
      <a-tab-pane class="tab-item" :tab="`${$t('global.stayPoints')}(${stayArr.length})`" key="2" >

        <!-- 使用list -->
        <a-list
          class="list"
          v-if="stayArr.length > 0"
          itemLayout="horizontal"
          :dataSource="stayArr"
          :pagination="stayArr.length > 3 ? pagination : false"
          size="small"
        >
          <a-list-item class="list-item" slot="renderItem" slot-scope="item, index">
            <!-- {{item.index}} -->
            <a-list-item-meta :key="index" @click="clickStayAddr(item)">
              <div slot="description">
                <div>{{item.address}}</div>
                <div>{{$t('supervise.locationType') + `: ${computedLocationType(item.loc_type).value}`}}<zx-icon :type="computedLocationIcon(item.loc_type)" /></div>
                <div>{{$t('global.stayTime') + item.duration}}</div>
              </div>
              <div slot="title" >{{item.startTime}}</div>
            </a-list-item-meta>
            <div slot="actions" class="item-index">{{item.index}}</div>
          </a-list-item>
        </a-list>
        <div class="empty" v-else>{{$t('global.noInfo')}}</div>
      </a-tab-pane>
      <a-tab-pane class="tab-item" :tab="`${$t('global.alarmPoints')}(${alarmArr.length})`" key="3">
        <!-- 使用list -->
         <a-list
          class="list"
          v-if="alarmArr.length > 0"
          itemLayout="horizontal"
          :dataSource="alarmArr"
          :pagination="alarmArr.length > 3 ? pagination : false"
          size="small"
        >
          <a-list-item class="list-item" slot="renderItem" slot-scope="item, index">
            <!-- {{item.index}} -->
            <a-list-item-meta :key="index" @click="clickAlarmAddr(item)">
              <div slot="description">
                <div>{{item.message}}</div>
                <div>{{$t('supervise.locationType') + `: ${computedLocationType(item.loc_type).value}`}}<zx-icon :type="computedLocationIcon(item.loc_type)" /></div>
                <div>{{item.address}}</div>
              </div>
              <div slot="title" >{{item.alarmTime}}</div>
            </a-list-item-meta>
            <div slot="actions" class="item-index">{{item.index}}</div>
          </a-list-item>
        </a-list>
        <div class="empty" v-else>{{$t('global.noInfo')}}</div>
      </a-tab-pane>

      <a-tab-pane class="tab-item" key="5">
        <!-- 使用list -->
        <div slot="tab">{{`${$t('global.movePoints')}(${moveArr.length})`}}</div>
         <a-list
          class="list"
          v-if="moveArr.length > 0"
          itemLayout="horizontal"
          :dataSource="moveArr"
          :pagination="moveArr.length > 4 ? paginationAll : false"
          size="small"
        >
          <a-list-item class="list-item" slot="renderItem" slot-scope="item, index">
            <!-- {{item.index}} -->
            <a-list-item-meta :key="index" @click="clickAllAddr(item)">
              <div slot="description">
                <!-- <div>{{item.message}}</div> -->
                <div>{{item.address}}</div>
                <div>{{$t('supervise.locationType') + `: ${computedLocationType(item.loc_type).value}`}}<zx-icon :type="computedLocationIcon(item.loc_type)" /></div>
              </div>
              <div slot="title" >{{item.time}}</div>
            </a-list-item-meta>
            <div slot="actions" class="item-index">{{item.index}}</div>
          </a-list-item>
        </a-list>
        <div class="empty" v-else>{{$t('global.noInfo')}}</div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import moment from 'moment'
import EntityInfo from '../../views/home/details/info'
import {httpModel} from '../../http/httpModel'
import {getLocalPosition} from '../../utils/getLocalPosition'
import {computedLocationIcon, computedLocationType} from '../../utils/homeFn'
export default {
  components: {
    EntityInfo
  },
  data () {
    return {
      stayArr: [],
      alarmArr: [],
      allArr: [],
      moveArr: [],
      pagination: {
        pageSize: 3,
        size: 'small'
      },
      paginationAll: {
        pageSize: 4,
        size: 'small'
      },
      titles: '',
      infos: ''
    }
  },
  props: {
    personInfo: {
      required: true
    },
    alarmPoints: {
      type: Array
    },
    stayPoints: {
      type: Array
    },
    allPoints: {
      type: Array
    },
    movePoints: {
      type: Array
    },
  },
  methods: {
    getLocalPosition,
    computedLocationIcon,
    computedLocationType,
    // convertPointToAddress (lng, lat, callback) {
    //   let curPoint = new BMap.Point(lng, lat)
    //   this.geoc.getLocation(curPoint, (res) => {
    //     // console.log(res)
    //     let addr = ''
    //     if (res.surroundingPois.length > 0) {
    //       addr = res.address + res.surroundingPois[0].title
    //     } else {
    //       addr = res.address
    //     }
    //     callback(addr)
    //   })
    // },
    formatStayData () {
      this.stayPoints.forEach((item, index) => {
        let point = new BMap.Point(item.lng, item.lat)
        // 由于此处是一个异步操作，所以返回的顺序是未知的，需要解析后再手动排序
        // this.getLocalPosition(point).then((addr) => {
          this.stayArr.push({
            point: {
              lng: item.lng,
              lat: item.lat
            },
            address: item.address,
            startTime: moment(item.timestamp * 1000).format('YYYY-MM-DD HH:mm'),
            // duration: moment.duration({seconds: item.stayTime}).humanize().replace(' ', ''),
            duration: moment.duration({seconds: item.stayTime}).humanize(),
            // duration: '3天',
            index: item.index,
            loc_type: item.loc_type
          })
          // 当长度相等的时候说明地址解析完成了
          // if (this.stayArr.length === this.stayPoints.length) {
            // 排序
            this.stayArr.sort((a, b) => a.index - b.index)
        //   }
        // })
      })
    },
    formatAlarmData () {
      // console.log(this.alarmPoints)
      this.alarmPoints.forEach((item, index) => {
        // this.convertPointToAddress(item.lng, item.lat, (addr) => {
        //   this.alarmArr.push({
        //     point: {
        //       lng: item.lng,
        //       lat: item.lat
        //     },
        //     addr,
        //     alarmTime: moment(item.timestamp * 1000).format('YYYY年MM月DD日 HH时MM分'),
        //     message: item.message,
        //     index
        //   })
        // })
        let point = new BMap.Point(item.lng, item.lat)
        // 由于此处是一个异步操作，所以返回的顺序是未知的，需要解析后再手动排序
        // this.getLocalPosition(point).then((addr) => {
          this.alarmArr.push({
            point: {
              lng: item.lng,
              lat: item.lat
            },
            address: item.address,
            alarmTime: moment(item.timestamp * 1000).format('YYYY-MM-DD HH:mm'),
            message: item.message,
            index: item.index,
            loc_type: item.loc_type
          })
          // 当长度相等的时候说明地址解析完成了
          // if (this.alarmArr.length === this.alarmPoints.length) {
            // 排序
            this.alarmArr.sort((a, b) => a.index - b.index)
        //   }
        // })
      })
    },
    formatAllData () {
      this.allPoints.forEach((item, index) => {
        item.index = index + 1
        let point = new BMap.Point(item.lng, item.lat)
        // 由于此处是一个异步操作，所以返回的顺序是未知的，需要解析后再手动排序
        // this.getLocalPosition(point).then((addr) => {
          let message
          if (item.message || item.stayTime) {
            if (item.stayTime) {
              message = this.$t('global.stayTime') + moment.duration({seconds: item.stayTime}).humanize()
            } else if (item.message) {
              message = item.message
            }
          } else {
            message = ''
          }
          this.allArr.push({
            point: {
              lng: item.lng,
              lat: item.lat
            },
            address: item.address,
            time: moment(item.timestamp * 1000).format('YYYY-MM-DD HH:mm'),
            message: message,
            index: item.index,
            loc_type: item.loc_type
          })
          // 当长度相等的时候说明地址解析完成了
          // if (this.allArr.length === this.allPoints.length) {
            // 排序
            this.allArr.sort((a, b) => a.index - b.index)
        //   }
        // })
      })
    },
    formatMoveData () {
      // console.log(this.movePoints)
      this.movePoints.forEach((item, index) => {
        let point = new BMap.Point(item.lng, item.lat)
        // 由于此处是一个异步操作，所以返回的顺序是未知的，需要解析后再手动排序
        // this.getLocalPosition(point).then((addr) => {
          this.moveArr.push({
            point: {
              lng: item.lng,
              lat: item.lat
            },
            address: item.address,
            time: moment(item.timestamp * 1000).format('YYYY-MM-DD HH:mm'),
            index: item.index,
            loc_type: item.loc_type
          })
          // 当长度相等的时候说明地址解析完成了
          // if (this.moveArr.length === this.movePoints.length) {
            // 排序
            this.moveArr.sort((a, b) => a.index - b.index)
        //   }
        // })
      })
    },
    clickAlarmAddr (item) {
      if(item.point.lat != 'NaN' && item.point.lng != 'NaN' ){
          this.$emit('setAlarmInfoWindow', item)
      }
    },
    clickStayAddr (item) {
      if(item.point.lat != 'NaN' && item.point.lng != 'NaN' ){
        this.$emit('setStayInfoWindow', item)
      }
    },
    clickAllAddr (item) {
      console.log(item)
      if(item.point.lat != 'NaN' && item.point.lng != 'NaN' ){
        this.$emit('setNoramlLabel', item)
      }
    },
    // 获取实体的详细数据
    getEntityDetailInfo () {
      Promise.all([httpModel.getEntityInfoById(this.personInfo.key), httpModel.getCustomEntityTitles()]).then(([infos, titles]) => {
        // console.log(1)
        this.titles = titles
        this.infos = infos.entity
      })
    }
  },
  mounted () {
    // console.log('mounted')
    // this.formatStayData()
    // this.formatAlarmData()
    // console.log(this.personInfo)
  },
  created () {
    this.getEntityDetailInfo()
    this.formatStayData()
    this.formatAlarmData()
    this.formatAllData()
    this.formatMoveData()
  },
  beforeDestroy () {
    // console.log('before')
  }
}
</script>
<style lang="less" scoped>
.person {
  // background-color: antiquewhite;
  max-width: 30vw; 
  .tab {
    .basic,.track {
      color: rgb(41, 40, 40);
      // font-size: 1.1em;
      // font-weight: 600;
      padding: 10px;
      p {
        margin: 5px 0 0 0;
      }
    }
    .empty {
      width: 100%;
      text-align: center;
    }
    .tab-item {
      position: relative;
      max-height: 500px;
      overflow-y: auto;
      .list {
        padding: 0 20px;
        .list-item {
          cursor: pointer;
          .item-index {
            width: 30px;
            height: 30px;
            line-height: 30px;
            border-radius: 50%;
            border: .5px solid rgb(214, 214, 214);
          }
        }
      }
    }
  }
}
</style>
